import { useEffect, useState } from 'react';
import Link from 'next/link';
import { Action, City } from '../../models';
import { http } from '../../lib/api/http';
import { V3, V4 } from '../../lib/api/urls';
import { activeStatus } from '../../constants/events';
import { H2 } from '../styled/typography';
import { PostCard } from '../posts/post-card';
import { CITIES_API_LIMIT, DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { getLocalStorageItem } from '../../lib/api/browserStorage';

export default function GorbiletRecommends() {
  const [recommends, setRecommends] = useState<{
    actions: Action[];
    slug: string;
  } | null>(null);
  const [city, setCity] = useState<City | null>(null);

  useEffect(() => {
    async function fetch() {
      const cities = await http.get(V3.cities, { limit: CITIES_API_LIMIT });
      const cityData =
        cities.results.find(
          (c: City) => c.url === getLocalStorageItem('current-city')
        ) || cities.results[0];

      const compilationsData = await http.get(V3.compilations.root, {
        city: cityData.id,
        is_gb_recommended: true,
      });
      const data = await http.get(V4.events, {
        ids: compilationsData.results[0].events.join(','),
        is_web: true,
        status: activeStatus,
        limit: 8,
        city: cityData.id,
      });

      setRecommends({
        actions: data.results,
        slug: compilationsData.results[0].slug,
      });
      setCity(cityData);
    }
    fetch();
  }, []);

  if (!city || !recommends) return null;

  return (
    <div
      css={{
        marginTop: 70,
        paddingBottom: 56,
      }}
    >
      <div>
        <H2
          css={{
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: 26,
            marginBottom: 8,
            color: '#333',
          }}
        >
          Вам может быть интересно
        </H2>
        <div
          css={{
            display: 'flex',
            flexWrap: 'wrap',
            margin: '0 -8px',
            overflowX: 'hidden',
            '.actions__item': {
              width: '25%',
              [DEVICE_SCREENS_MAX_STRING.xl]: {
                width: 'calc(100% / 3)',
              },
              [DEVICE_SCREENS_MAX_STRING.md]: {
                width: '50%',
              },
              [DEVICE_SCREENS_MAX_STRING.sm]: {
                width: '100%',
                maxWidth: '100%',
              },
            },
            [DEVICE_SCREENS_MAX_STRING.sm]: {
              width: 'unset',
              flexWrap: 'nowrap',
              flexDirection: 'column',
            },
          }}
        >
          {!!recommends.actions.length &&
            recommends.actions.map((action) => (
              <PostCard key={action.id} item={action} currentCity={city} />
            ))}
        </div>
      </div>

      <div css={{ display: 'flex', justifyContent: 'center' }}>
        <Link
          href={['', city.url, 'compilations', recommends.slug, ''].join('/')}
        >
          <button
            type='button'
            css={{
              fontFamily: 'Golos',
              fontSize: 16,
              fontWeight: 500,
              lineHeight: '16px',
              color: '#fff',
              width: 260,
              height: 41,
              backgroundColor: '#ff4a2e',
              backgroundImage:
                'linear-gradient(120deg, #ff4a2e 0%, #de2839 100%)',
              backgroundSize: '500% 500%',
              animation: 'move-background 60s linear infinite',
              transition: 'all 0.2s ease, box-shadow 0.4s ease',
              borderRadius: 30,
              marginTop: 25,
            }}
          >
            Все мероприятия
          </button>
        </Link>
      </div>
    </div>
  );
}
